import BrokenFlowModal from "./BrokenFlowModal";
import withErrorFallbacksContext from "../withModuleContext";

export default withErrorFallbacksContext(BrokenFlowModal);
